<template>
  <v-data-table
    :loading="loading"
    :headers="headers"
    :items="events"
    :search="search"
  />
</template>
<script>
  export default {
    name: 'InfinityEvents',
    props: {
      search: {
        type: String,
        default: () => '',
      },
      filter: {
        type: String,
        default: () => '',
      },
    },
    data: () => {
      return {
        headers: [
          { text: 'Timestamp', value: 'CreatedAt', filterable: true },
          { text: 'Severity', value: 'Severity', filterable: true },
          { text: 'Type', value: 'Type', filterable: true },
          { text: 'Description', value: 'Description', filterable: true },
        ],
      }
    },
    computed: {
      events () {
        const events = this.$store.state.app.events
        if (!this.filter) {
          return events
        }
        const re = new RegExp(this.filter)
        return events.filter(event => re.test(event.ObjectId))
      },
      loading () {
        return this.$store.state.app.events.length === 0
      },
    },
  }
</script>
